import { Box, IconButton, Typography, styled } from '@mui/material';

export const PaymentPlanBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontSize: theme.typography.pxToRem(24),
  gap: theme.spacing(4)
}));

export const IconButtonStyled = styled(IconButton)(() => ({
  position: 'absolute',
  top: 20,
  left: 20
}));

export const PaymentPlanContainer = styled(Box)(({ theme }) => ({
  padding: 20,
  display: 'flex',
  width: '100%',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    paddingTop: 40
  }
}));

export const RootBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  maxWidth: '1440px',
  width: '100%',
  justifyContent: 'center',
  gap: theme.spacing(1),
  marginBottom: 80
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4)
}));

export const BackAndLogoBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'flex-start'
}));

export const LogoBox = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center'
}));

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(40),
  fontWeight: 500,
  minWidth: '70%',
  maxWidth: '70%',
  whiteSpace: 'pre-wrap',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    minWidth: '90%',
    maxWidth: '90%'
  }
}));

export const PlatesBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  border: `${theme.typography.pxToRem(1)} solid #A3A3A3`,
  borderRadius: theme.typography.pxToRem(8),
  width: '90%',
  [theme.breakpoints.up('md')]: {
    width: theme.typography.pxToRem(699)
  }
}));

export const HorizontalContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  minWidth: '70%',
  maxWidth: '70%',
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    minWidth: '90%',
    maxWidth: '90%'
  }
}));

export const CreditCardContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  minWidth: '70%',
  maxWidth: '70%',
  boder: `${theme.typography.pxToRem(1)} solid #A3A3A3`,
  borderRadius: theme.typography.pxToRem(8),
  gap: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    minWidth: '90%',
    maxWidth: '90%'
  }
}));
